export default "__VITE_ASSET__BdQPOcOt__"